<template>
<div>
  <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
      <!-- <div v-if="successfully_feedback === false"> -->
      <div id="url_expired" style="text-align: center; width: 90%;">
        <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
     <div id="url_valid">
      <div>
        <div id="border">
            <div style="text-align:center; margin-bottom: 10px;" id="milk_test_date">
              <h4>Test Date</h4>
              <div class="display_test_date"><b>{{test_date}}</b></div>
            </div>
          <form @submit= "submitDailyMilkTestReportData()">
            <div style="text-align:center; margin-bottom: 10px;" id="display_cow_milk_test_result">
              <h4>Cow Milk Test Result</h4>
                <div class="row">
                    <div style="width: 50%; margin-top: 10px;">
                        <div style="text-align:right;"><strong><label>FAT</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>CLR</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>SNF</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 20px;"><strong><label>UREA</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>STARCH</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>DETERGENT</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>ANTIBIOTICS</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>ALCOHOL</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>CAUSTIC</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                    </div>
                    <div style="width: 50%;">
                      <div style="text-align:left; margin-bottom: 10px;"><input v-bind:class="{'inp readonlytextbox': lock,  'inp': 1 }" type = "number" name="cow_test_fat" id="cow_test_fat" step="0.01" maxlength="4" v-on:blur="calCowSNF()" v-model= cow_test.fat min="3" value="" max="5" required :readonly="lock == 1"></div>
                      <div style="text-align:left; margin-bottom: 10px;"><input v-bind:class="{'inp readonlytextbox': lock,  'inp': 1 }" type = "number" name="cow_test_clr" id="cow_test_clr" step="0.01" maxlength="4" v-on:blur="calCowSNF()" v-model= cow_test.clr min="20.0" max="35.0" required :readonly="lock == 1"></div>
                      <div style="text-align:left; margin-bottom: 10px;"><input class="inp readonlytextbox" type = "number" name="cow_test_snf" id="cow_test_snf" maxlength="4" v-model="cow_test.snf" required readonly></div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_urea" type="checkbox" id="cow_test_urea" v-model= cow_test.urea :disabled="lock == 1">
                          <label for="cow_test_urea">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>                    
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_starch" type="checkbox" id="cow_test_starch" v-model= cow_test.starch :disabled="lock == 1" >
                          <label for="cow_test_starch">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_detergent" type="checkbox" id="cow_test_detergent" v-model= cow_test.detergent :disabled="lock == 1" >
                          <label for="cow_test_detergent">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_antibiotic" type="checkbox" id="cow_test_antibiotic" v-model= cow_test.antibiotic :disabled="lock == 1" >
                          <label for="cow_test_antibiotic">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>                    
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_alcohol" type="checkbox" id="cow_test_alcohol" v-model= cow_test.alcohol :disabled="lock == 1" >
                          <label for="cow_test_alcohol">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="cow_test_caustic" type="checkbox" id="cow_test_caustic" v-model= cow_test.caustic :disabled="lock == 1" >
                          <label for="cow_test_caustic">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                    </div>
                </div>  
            </div>
            <div style="text-align:center; margin-bottom: 10px;" id="display_cow_milk_test_result">
              <h4>Buffalo Milk Test Result</h4>
                <div class="row">
                    <div style="width: 50%; margin-top: 10px;">
                        <div style="text-align:right;"><strong><label>FAT</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>CLR</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>SNF</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 20px;"><strong><label>UREA</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>STARCH</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>DETERGENT</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>ANTIBIOTICS</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>ALCOHOL</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>CAUSTIC</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                        <div style="text-align:right; margin-top: 15px;"><strong><label>Lock Report</label>&nbsp;&nbsp;:&nbsp;&nbsp;</strong></div>
                    </div>
                    <div style="width: 50%;">
                      <div style="text-align:left; margin-bottom: 10px;"><input v-bind:class="{'inp readonlytextbox': lock,  'inp': 1 }" type = "number" name="buff_test_fat" id="buff_test_fat" step="0.01" maxlength="4" v-on:blur="calBuffSNF()" v-model= buff_test.fat min="5.5" max="7.5" required :readonly="lock == 1"></div>
                      <div style="text-align:left; margin-bottom: 10px;"><input v-bind:class="{'inp readonlytextbox': lock,  'inp': 1 }" type = "number" name="buff_test_clr" id="buff_test_clr" step="0.01" maxlength="4" v-on:blur="calBuffSNF()" v-model= buff_test.clr min="20" max="35" required :readonly="lock == 1"></div>
                      <div style="text-align:left; margin-bottom: 10px;"><input class="inp readonlytextbox" type = "number" name="buff_test_snf" id="buff_test_snf" step="0.01" maxlength="4" v-model= buff_test.snf required readonly></div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_urea" type="checkbox" id="buff_test_urea" v-model= buff_test.urea :disabled="lock == 1" >
                          <label for="buff_test_urea">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>                    
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_starch" type="checkbox" id="buff_test_starch" v-model= buff_test.starch :disabled="lock == 1" >
                          <label for="buff_test_starch">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_detergent" type="checkbox" id="buff_test_detergent" v-model= buff_test.detergent :disabled="lock == 1" > 
                          <label for="buff_test_detergent">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_antibiotic" type="checkbox" id="buff_test_antibiotic" v-model = buff_test.antibiotic :disabled="lock == 1" >
                          <label for="buff_test_antibiotic">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>                    
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_alcohol" type="checkbox" id="buff_test_alcohol" v-model= buff_test.alcohol :disabled="lock == 1" >
                          <label for="buff_test_alcohol">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                      <div class="my-toggle-btn-wrapper" style="margin-top: 15px;">
                        <div class="my-toggle-btn">
                          <input name="buff_test_caustic" type="checkbox" id="buff_test_caustic" v-model= buff_test.caustic :disabled="lock == 1" >
                          <label for="buff_test_caustic">
                            <span class="on">Pos(+)</span>
                            <span class="off">Neg(-)</span>
                          </label>
                        </div>
                      </div>
                    <div style="margin-top: 15px;text-align: left;"><input id="resize_checkbox" type="checkbox" name="lock_report" v-model = lock_report :disabled="lock ==1 "></div>
                    </div>
                </div>  
            </div>
            <div>
              <input class="button" type="submit" value="Submit Test" :disabled="lock == 1">
            </div>
          </form>
          </div>
      </div>
      </div>
      </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  // import VueAxios from 'vue-axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        isLoading: true,
        isFullPage: true,
        urlInterface: [],
        successfully_feedback: false,
        obj: {},
        test_date: String,
        cow_test: {
          fat: 0,
          clr: 0,
          snf: 0
        },
        buff_test: {
          fat: 0,
          clr: 0,
          snf: 0
        },
        lock_report: 0,
        lock: 0
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        // console.log(process.env.BASE_API+ '/accounts/fetch-url-interface-data')
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('uploadDailyMilkTestReport?')
        params.append('url_str', splitUrl[1])
        // console.log(splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
            this.isLoading = false
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.urlInterface.sub_action_name = 'load'
            this.urlInterface.vue_url = fullUrl
            this.invokeUrlAction()
          }
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        })
        .catch(e => {
          this.isLoading = false
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        params.append('sub_action_name', this.urlInterface.sub_action_name)
        switch (this.urlInterface.sub_action_name) {
          case 'load':
            break
          case 'update':

            params.append('cow_test_snf', this.cow_test.snf)
            params.append('cow_test_clr', this.cow_test.clr)
            params.append('cow_test_fat', this.cow_test.fat)
            params.append('cow_test_urea', this.cow_test.urea ? 1 : 0)
            params.append('cow_test_starch', this.cow_test.starch ? 1 : 0)
            params.append('cow_test_detergent', this.cow_test.detergent ? 1 : 0)
            params.append('cow_test_caustic', this.cow_test.caustic ? 1 : 0)
            params.append('cow_test_antibiotic', this.cow_test.antibiotic ? 1 : 0)
            params.append('cow_test_alcohol', this.cow_test.alcohol ? 1 : 0)

            params.append('buff_test_snf', this.buff_test.snf)
            params.append('buff_test_clr', this.buff_test.clr)
            params.append('buff_test_fat', this.buff_test.fat)
            params.append('buff_test_urea', this.buff_test.urea ? 1 : 0)
            params.append('buff_test_starch', this.buff_test.starch ? 1 : 0)
            params.append('buff_test_detergent', this.buff_test.detergent ? 1 : 0)
            params.append('buff_test_caustic', this.buff_test.caustic ? 1 : 0)
            params.append('buff_test_antibiotic', this.buff_test.antibiotic ? 1 : 0)
            params.append('buff_test_alcohol', this.buff_test.alcohol ? 1 : 0)
            params.append('lock_report', this.lock_report ? 1 : 0)
            break
          default:
            break
        }
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.obj = response.data.action_response
          switch (this.urlInterface.sub_action_name) {
            case 'load':

              this.test_date = this.obj.test_date
              this.cow_test.fat = this.obj.cow_test_fat
              this.cow_test.snf = this.obj.cow_test_snf
              this.cow_test.clr = this.obj.cow_test_clr
              this.cow_test.urea = this.obj.cow_test_urea
              this.cow_test.starch = this.obj.cow_test_starch
              this.cow_test.detergent = this.obj.cow_test_detergent
              this.cow_test.caustic = this.obj.cow_test_caustic
              this.cow_test.antibiotic = this.obj.cow_test_antibiotic
              this.cow_test.alcohol = this.obj.cow_test_alcohol
              this.buff_test.snf = this.obj.buff_test_snf
              this.buff_test.clr = this.obj.buff_test_clr
              this.buff_test.fat = this.obj.buff_test_fat
              this.buff_test.urea = this.obj.buff_test_urea
              this.buff_test.starch = this.obj.buff_test_starch
              this.buff_test.detergent = this.obj.buff_test_detergent
              this.buff_test.caustic = this.obj.buff_test_caustic
              this.buff_test.antibiotic = this.obj.buff_test_antibiotic
              this.buff_test.alcohol = this.obj.buff_test_alcohol
              this.lock_report = this.obj.lock_report
              if (this.lock_report === 1) {
                this.lock = 1
              }
              break
            case 'update':
              break
            default:
              break
          }
          setTimeout(() => {
            this.isLoading = false
          }, 10000)
        })
        .catch(e => {
        })
      },

      calCowSNF: function () {
        this.cow_test.snf = ((this.cow_test.fat / 5) + (this.cow_test.clr / 4) + 0.6).toFixed(2)
      },

      calBuffSNF: function () {
        this.buff_test.snf = ((this.buff_test.fat / 5) + (this.buff_test.clr / 4) + 0.6).toFixed(2)
      },

      submitDailyMilkTestReportData: function () {
        this.urlInterface.sub_action_name = 'update'
        this.invokeUrlAction()
      }
    }
  }
</script>
<style>
.inp {width: 170px; height: 40px;}
.my-toggle-btn-wrapper{
  text-align: left;
}
.my-toggle-btn{
  cursor: pointer;
  display: inline-block;
}
.my-toggle-btn input[type=checkbox]{
  display: none;
}
.my-toggle-btn label{
    background:  #4caf50;
    color: #fff;
    width: 120px;
    height: 24px;
    font-family: 'Roboto Slab', serif;
    display: inline-block;
    border-radius: 1px;
    position: relative;
    text-align: center;
    transition: all .4s ease;
    cursor: pointer;
}
.my-toggle-btn label:before{
    content: '';
    position: absolute;
    height: 26px;
    width: 26px;
    background: #444;
    left: 2px;
    top: -1px;
    transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;
}
.my-toggle-btn input[type=checkbox]:checked + label:before{
  left: 92px;
  transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;
}
.my-toggle-btn input[type=checkbox]:checked + label span.off{
  display: none;
}
.my-toggle-btn input[type=checkbox]:checked + label span.on{
  display: inline;
}
.my-toggle-btn input[type=checkbox] + label span.on{
  display: none;
}
.my-toggle-btn input[type=checkbox] + label span.off{
  display: inline;
}

.my-toggle-btn input[type=checkbox]:checked + label{
  background: #f44336;
}

#border {
  border: .01px solid black;
  padding: 15px;
  background: lightblue !important;
  background-clip: border-box;  
}
.wrapper {
    text-align: center;
}

.readonlytextbox {
  background-color: #e9e9e9;
  border: .01px solid #e9e9e9;
}

#resize_checkbox { 
            width: 20px; 
            height: 20px; 
        } 


</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/UploadDailyMilkTestReport.vue